import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Button, EnrollmentFileUploader as FileUploader, Label } from "../../../../../components/formInputs";
import {
    DatePicker,
    ErrorCommon,
    ErrorHelper,
    NumberTextField,
    NumberTextFieldWithCb,
    SelectField,
    TextField,
    TextFieldCommon,
} from "../../../../../components/formikFormInputs";
import {
    ExpansionPanel,
    ExpansionPanelDetails,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import numeral from "numeral";
import moment from "moment";
import PolicyYearDocTable from "./PolicyYearDocTable";
import {Field, FieldArray, useFormikContext} from "formik";
import {checkRole, isDebug, parseAndFormat, parseAndFormatWithZeroMinus, pez} from "../../../../../utils/commonUtils";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import selectField from "../../../../../components/formikFormInputs/SelectField";
import {allocationFieldForm} from "../../../Estimation/utils/utils";
import {useActions} from "../../../../../actions";
import FlexiPayments from "../../../../../components/clientServicing/Payments/FlexiPayments";
import {usePolicyContext} from "../../../../../components/clientServicing/Payments/PolicyContext";
import {PaymentFrequency} from "../../../../../components/clientServicing/Payments";
import * as EstimationActions from "../../../../../actions/estimation";
import * as EstimatorActions from "../../../../../actions/estimator";
import EstimationFormContext from "../../../Estimation/V1/Context/EstimationFormContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducers";
import * as CActions from "../../../../../actions/client";
import DeleteIcon from "@material-ui/icons/Delete";
import * as account from "../../../../../actions/account";
import { AccountType, ClientDocumentType, surrenderOptions, yesNoDropDown } from "../../../../../constants";
import { Dialog as GenericDialog, GenericDialogProps } from "../../../../../components/dialog";
import {
    actualIntAmt,
    addNumbers,
    dailyInt,
    getAnniversaryDate,
    intAccrued,
} from "../../../../../utils/commonFormulas";
import ViewAndDelete from "../../../Enrollment/allianzAppHome/basicInfo/ViewAndDelete";
import { Enrollment } from "../../../../../model/enrollment";
import { Client } from "../../../../../model/account";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    fileUpload: {
        padding: "15px !important",
        border: "1px dashed rgba(0, 0, 0, 0.23)",
        backgroundColor: "#f4f5f7",
        cursor: "pointer",
    },
}));

interface AllocationField {
    id?: number;
    allocationId: string;
    optionName?: string;
    indexAllocationPercent: string;
    indexCreditAmount: string;
    indexCreditPercent: string;
    indexBonusAmount: string;
    indexCurrentValue: string;
    indexParticipationRate: string;
    indexCap: string;
    indexLock: string;
}

interface PolicyBreakdownValues {
    currentAge: number;
    paymentFrequency: string;
    deathBenefitReduction: number;
    adminClientAllocations: AllocationField[];
    statementAllocations: AllocationField[];
    illustratedPremium: number;
    bankPremium: number;
    loanRate: number;
    projectedInterest: number;
    estLoanBalance: number;
    illustratedSurrenderValue: number;
    netCashValueIllustrated: number;
    netLoanCashValueIllustrated: number;
    illustratedCurrentDeathBenefit: number;
    illustratedNetDeathBenefit: number;
    lowPoint: number;
    illustratedGrowthRate: number;
    insurancePremiumActual: number;
    growthPercent: number;
    growthAmount: number;
    actualSurrenderValue: number;
    actualCurrentDeathBenefit: number;
    actualLowPoint: number;
    bankLoanPremiumDue: number;
    bankInterestRate: number;
    bankLoanBasis: number;
    dailyInterestAccrual: number;
    interestAccruedYTD: number;
    actualInterestAmount: number;
    loanBalanceYTD: number;
    bankLoanAmount: number;
    arrangementFee: number;
    loanAmount: number;
    actualCurrentSurrenderValue: number;
    amountPaidToClient: number;
    dateOfSurrender: string;
    perDiem: number;
    surrenderOptions?: string;
    surrenderCompleted: string;
    reasonForChange?: string;
    amountPaidToPolicy: number;
    cumulativeContributionPaid: number;
    cumulativeEmployerContributionPaid: number;
    cumulativeBankLoanPremiumPaid: number;
    actualNetSurrenderValue: number;
    netDeathBenefitActual: number;
    growthRateAverage: number;
    loanRateAverage: number;
    bankLoanPremiumDueUpdated?: boolean;
    bankInterestRateUpdated?: boolean;
    bankLoanBasisUpdated?: boolean;
    stmCumulativePaidToPolicy: number;
    stmSurrenderValue: number;
    stmPremium: number;
    stmDeathBenefit: number;
    stmTotalCreditedAmount: number;
    stmTotalValue: number;
    stmWeightedGrowthRate: number;
    netStmSurrenderValue: number;
    netStmDeathBenefits: number;
}

interface CaseDetails {
    id: number;
    carrierId?: number;
    strategyId?: number;
    tranche?: any;
    policyBreakDowns?: any;
    paymentFrequency?: string;
    enrollment?: Enrollment,
    client?: Client | undefined
}

interface YearPolicyBreakup {
    decliningDB: number;
    decliningDBOther?: string;
    dbNotes?: string;
    dbRequest: string;
    id?: number;
}

interface BreakDownFormPanelProps {
    setPolicyArr: Function;
    policyArr: any[];
    policyArrIndex: number;
    year: number;
    setRefresh: Function;
    setPolicyFormDirty: Function;
    yearPolicyBreakup: YearPolicyBreakup;
    outStandingBalance: number;
    fetchCaseDetail: Function;
    expanded: boolean | string;
    combineClientObj: { key: number; name: string; title: string };
    caseDetails: CaseDetails;
}
// Constants
const BANK_LOAN_BASIS_DAYS = 365;
const BANK_INTEREST_DAYS = 360;
const MIN_DELETABLE_ALLOCATION_INDEX = 1;

const bonusLabels = {
    1: { code: "select" , label: "Select"},
    2: { code: "classic" , label: "Classic"},
    3: { code: "standard" , label: "Standard"},
    4: { code: "bonus" , label: "Bonus"},
}

// Calculation Utility Functions
const calculateActualInterestAmount = (
    bankLoanPremiumDue: number,
    arrangementFee: number,
    bankInterestRate: number
): number => {
    return (bankLoanPremiumDue + arrangementFee) * (bankInterestRate * BANK_LOAN_BASIS_DAYS / BANK_INTEREST_DAYS);
};
const calculateBankLoanAmount = (
    bankLoanPremiumDue: number,
    arrangementFee: number,
    actualInterestAmount: number
): number => {
    return bankLoanPremiumDue + arrangementFee + actualInterestAmount;
};

const calculateNetDeathBenefit = (
    actualCurrentDeathBenefit: number,
    bankLoanAmount: number
): number => {
    return actualCurrentDeathBenefit - bankLoanAmount;
};
const calculateNetSurrenderValue = (
    actualSurrenderValue: number,
    bankLoanAmount: number
): number => {
    return actualSurrenderValue - bankLoanAmount;
};

const calculateNetStmSurrenderValue = (
    stmSurrenderValue: number,
    estLoanBalance: number
): number => {
    return stmSurrenderValue - estLoanBalance;
};

const calculateNetStmDeathBenefits = (
    stmDeathBenefit: number,
    estLoanBalance: number
): number => {
    return stmDeathBenefit - estLoanBalance;
};

const BreakDownFormPanel1 = (props: BreakDownFormPanelProps) => {
    let n = 0;
    const {
        setPolicyArr,
        policyArr,
        policyArrIndex,
        year,
        setRefresh,
        setPolicyFormDirty,
        yearPolicyBreakup,
        caseDetails,
    } = props;
    const [optionName, setOptionName] = useState<any>([]);
    const classes = useStyles();
    const { values, errors, touched, handleChange, setFieldValue }: any = useFormikContext();
    const inputRefs = React.useRef({});
    const estimationActions = useActions(EstimationActions);
    const estimatorActions = useActions(EstimatorActions);
    const  accountActions  = useActions(account);
    const { estimatorId } = useContext<any>(EstimationFormContext);
    const { user } = useSelector((state: RootState) => state.auth);
    const carrierId = (caseDetails && caseDetails.carrierId) || (user.accessType === "client" ? user.demoCarrierId : (user.client && user.client.carrier ? user.client.carrier.id : 2));
    const strategyId = (caseDetails && caseDetails.strategyId) || (user.accessType === "client" ? user.demoCarrierId : (user.client && user.client.strategy ? user.client.strategy.id : 2));
    const anniversaryDate = getAnniversaryDate(caseDetails && caseDetails.tranche && caseDetails.tranche.issueDate);
    const foundEstimatedLB = policyArrIndex >= 1 ? caseDetails && caseDetails.policyBreakDowns.find(item => item.policyYear === (year - 1)) : 0;
    const directory: string | undefined = caseDetails && caseDetails.enrollment && caseDetails.enrollment.id;
    const fileType: string = "image/jpg, image/jpeg, image/png, application/pdf";
    const clientSigned: boolean = !!(caseDetails && caseDetails.enrollment && caseDetails.enrollment.clientSigned);
    const [estimatorDataId, setEstimatorDataId] = React.useState<any | null>(estimatorId);
    const [bVPopUpOpen, setBVPopUpOpen] = React.useState(false);
    const [activeField, setActiveField] = React.useState("");
    const [decliningDB, setDecliningDB] = React.useState<number>(0);
    const [addDbNotes, setAddDbNotes] = React.useState<boolean>(false);
    const [uploadClientDBRequest, setUploadClientDBRequest] = React.useState("");
    const lockOptions = [
        { id: 1, key: 1, value: "Locked", name: "Locked" },
        { id: 2, key: 2, value: "Unlocked", name: "Unlocked" }
    ];
    const getEstimatorDataFromApi = async (query: Partial<{ strategyId: number, carrierId: number }>) => {
        if (query.carrierId && query.strategyId) {
            const res = await estimatorActions.getEstimatorDetails(query);
            if (!!res) {
                setEstimatorDataId(res.id);
            }
        }
    };

    React.useEffect(() => {
        setDecliningDB(yearPolicyBreakup && yearPolicyBreakup.decliningDB || 0);
        const dbNotes = yearPolicyBreakup && yearPolicyBreakup.dbNotes;
        setAddDbNotes(!!dbNotes);
        setUploadClientDBRequest(yearPolicyBreakup && yearPolicyBreakup.dbRequest);
    }, [yearPolicyBreakup]);

    React.useEffect(() => {
        if (!estimatorId) {
            let query: Partial<{ strategyId: number, carrierId: number }> = {};
            query = {
                strategyId: strategyId,
                carrierId: carrierId,
            };
            getEstimatorDataFromApi(query).then(() => {
            });
        }
    }, [strategyId, carrierId]);

    const prevAllocationIds = useRef<number[]>([]);

    React.useEffect(() => {
        values && values.adminClientAllocations && values.adminClientAllocations.forEach((row, i) => {
            const prevId = prevAllocationIds.current[i];
            // only update optionName if allocationId changed
            if (row.allocationId && row.allocationId !== prevId) {
                const match = optionName.find(
                    opt => Number(opt.key) === Number(row.allocationId)
                );

                if (match) {
                    setFieldValue(`adminClientAllocations[${i}].optionName`, match.name);
                }
            }
        });
        // update ref after processing
        prevAllocationIds.current = values && values.adminClientAllocations &&  values.adminClientAllocations.map(r => r.allocationId) || [];
    }, [JSON.stringify(values && values.adminClientAllocations), optionName, setFieldValue]);

    React.useEffect(() => {
        (async () => {
            if (estimatorDataId) {
                const res = await estimationActions.getAllocationQuestions({
                    estimatorId: estimatorDataId,
                    carrierId: carrierId,
                    fetchAll: true,
                });
                if (res) {
                    const data: any = [];
                    const values = {};
                    res.forEach((fields) => {
                        values[fields.id] = fields;
                        data.push({
                            key: fields.id,
                            value: fields.id,
                            name: fields.label + (fields.bonusType && bonusLabels[fields.bonusType] ? ' ' + bonusLabels[fields.bonusType].label : ''),
                        });
                    });
                    setOptionName(data);
                    setFieldValue(allocationFieldForm, values);

                }
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [estimatorDataId, carrierId]);

    const [paymentData, setPaymentData] = React.useState({})

    const { policy, refetchPolicy } = usePolicyContext();

    const paymentFrequency = pez(caseDetails.paymentFrequency);

    const updateDocument = async (key: string, value: string | string[], field: string, documentSubType: string = "", docName: string | null = null) => {
        let payload: {
            formType?: string,
            uploadClientDBRequest?: string,
            docName: string | null,
        } = {
            formType: "documents",
            uploadClientDBRequest: uploadClientDBRequest,
            docName: docName,
        };
        payload[key] = value;
        payload["documentType"] = field;
        payload["documentSubType"] = documentSubType;
        payload["documentKey"] = key;
        payload["operation"] = payload[payload["documentKey"]] ? "Uploaded" : "Deleted";
        payload["docName"] = docName;
        payload["policyYear"] = year;
        if (caseDetails && caseDetails.id && directory) {
            try {
                await accountActions.updateUserBasicDetails(payload, caseDetails && caseDetails.id);
            } catch (err) {
                console.log("err", err);
                return false;
            }
        }
    };

    const updateSurrenderValues = (e: any, isBankLoanAmountValue: boolean = false) => {
        const val = numeral(e.target.value).value();
        const bankLoanAmountVal = isBankLoanAmountValue ? val : numeral(values.bankLoanAmount).value();
        const actualSurrenderVal = isBankLoanAmountValue ? numeral(values.actualSurrenderValue).value() : val;

        const result = calculateNetSurrenderValue(actualSurrenderVal, bankLoanAmountVal);
        setFieldValue("actualNetSurrenderValue", parseAndFormatWithZeroMinus(result));
    };

    let fieldObj = [
        {
            id: "currentAge",
            name: "currentAge",
            label: <Label label={"Client Age"} />,
            placeholder: "Current Age",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            disabled: true,
        },
        {
            id: "paymentFrequency",
            name: "paymentFrequency",
            label: <Label label={"Contribution Frequency"} />,
            placeholder: "Contribution Frequency",
            component: TextField,
            disablePast: false,
            className: "fullWidthcustomFields",
            disabled: true,
        },
        {
            id: "deathBenefitReduction",
            name: "deathBenefitReduction",
            label: <Label label={"Death Benefit Reductions"} />,
            placeholder: "Death Benefit Reductions",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            helperText: "Value cannot be negative.",
            allowNegative: false,
        },
        {
            id: "revisedDeathBenefitAmount",
            name: "revisedDeathBenefitAmount",
            label: <Label label={"Revised Death Benefit Amount"} />,
            placeholder: "Revised Death Benefit Amount",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon" position="start">$</InputAdornment>,
            },
            helperText: "Value cannot be negative.",
            allowNegative: false,
        }
    ];

    const adminClientAllocations = [
        {
            id: "allocationId",
            name: "allocationId",
            label: <Label label={"Option Name"} />,
            isRequired: true,
            component: selectField,
            options: optionName,
            fieldType: "string",
            variant: "outlined",
            onChange: (e) => {
                handleChange(e);
            },
        },
        {
            id: "optionName",
            name: "optionName",
            label: <Label label={"Other Option Name"} />,
            placeholder: "Enter Option Name",
            isRequired: false,
            component: TextField,
            variant: "outlined",
            onChange: (e) => {
                handleChange(e);
            },
            conditional: true,
        },
        {
            id: "indexAllocationPercent",
            name: "indexAllocationPercent",
            label: <Label label={"Allocation Percentage"} />,
            placeholder: "Allocation Percentage",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            allowMax100: true,
            onChange: (e) => {
                handleChange(e);
            },
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
            InputLabelProps:{
                shrink: true,
            },
        },
        {
            id: "indexCreditAmount",
            name: "indexCreditAmount",
            label: <Label label={"Amount Credited"} />,
            placeholder: "Amount Credited",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            onChange: (e) => {
                handleChange(e);
            },
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            InputLabelProps:{
                shrink: true,
            },
        },
        {
            id: "indexCreditPercent",
            name: "indexCreditPercent",
            label: <Label label={"Growth Percent"} />,
            placeholder: "Growth Percent",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            allowMax100: true,
            onChange: (e) => {
                handleChange(e);
            },
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
            InputLabelProps:{
                shrink: true,
            },
        },
        {
            id: "indexBonusAmount",
            name: "indexBonusAmount",
            label: <Label label={"Index Bonus Amount"} />,
            placeholder: "Index Bonus Amount",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            onChange: (e) => {
                handleChange(e);
            },
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            InputLabelProps:{
                shrink: true,
            },
        },
        {
            id: "indexCurrentValue",
            name: "indexCurrentValue",
            label: <Label label={"Index Value"} />,
            placeholder: "Index Value",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            onChange: (e) => {
                handleChange(e);
            },
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            InputLabelProps:{
                shrink: true,
            },
        },
        {
            id: "indexParticipationRate",
            name: "indexParticipationRate",
            label: <Label label={"Participation Rate"} />,
            placeholder: "Participation Rate",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            allowMax100: true,
            onChange: (e) => {
                handleChange(e);
            },
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
            InputLabelProps:{
                shrink: true,
            },
        },
        {
            id: "indexCap",
            name: "indexCap",
            label: <Label label={"Cap"} />,
            placeholder: "Cap",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            allowMax100: true,
            onChange: (e) => {
                handleChange(e);
            },
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
            InputLabelProps:{
                shrink: true,
            },
        },
        {
            id: "indexLock",
            name: "indexLock",
            label: <Label label={"Index Lock"} />,
            isRequired: true,
            component: selectField,
            options: lockOptions,
            fieldType: "number",
            variant: "outlined",
            onChange: (e) => {
                handleChange(e);
            },
        },
    ];

    const illustratedValue = [
        {
            id: "illustratedPremium",
            name: "illustratedPremium",
            label: <Label label={"Illustrated Premium   "} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "bankPremium",
            name: "bankPremium",
            label: <Label label={"Bank Premium"} />,
            placeholder: "Bank Premium",
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "loanRate",
            name: "loanRate",
            label: <Label label={"loan Rate"} />,
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            allowMax100: true,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "projectedInterest",
            name: "projectedInterest",
            label: <Label label={"Projected Interest"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            helperText: "Through loan anniversary.",
            allowNegative: false,
        },
        {
            id: "estLoanBalance",
            name: "estLoanBalance",
            label: <Label label={"Est. Loan Balance"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                const stmSurrenderVal = numeral(values.stmSurrenderValue).value();
                const stmDeathBenefitsVal = numeral(values.stmDeathBenefit).value();
                const result = calculateNetStmSurrenderValue(stmSurrenderVal, val);
                const deathBenefitsResult = calculateNetStmSurrenderValue(stmDeathBenefitsVal, val);
                setFieldValue("netStmSurrenderValue", parseAndFormat(result));
                setFieldValue("netStmDeathBenefits", parseAndFormat(deathBenefitsResult))
                setFieldValue("estLoanBalance", val)
            },
            allowNegative: false,
        },
        {
            id: "illustratedSurrenderValue",
            name: "illustratedSurrenderValue",
            label: <Label label={"Illustrated Surrender Value"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "netCashValueIllustrated",
            name: "netCashValueIllustrated",
            label: <Label label={"Estimated Cash Value"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "netLoanCashValueIllustrated",
            name: "netLoanCashValueIllustrated",
            label: <Label label={"Net of Loan Cash Value Illustrated"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
        },
        {
            id: "illustratedCurrentDeathBenefit",
            name: "illustratedCurrentDeathBenefit",
            label: <Label label={"Illustrated Current Death Benefit"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "illustratedNetDeathBenefit",
            name: "illustratedNetDeathBenefit",
            label: <Label label={"Illustrated Net Death Benefit"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "lowPoint",
            name: "lowPoint",
            label: <Label label={"Low Point"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "illustratedGrowthRate",
            name: "illustratedGrowthRate",
            label: <Label label={"Illustrated Growth Rate"} />,
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            allowMax100: true,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
        },
    ];

    const carrierValues = [
        {
            id: "insurancePremiumActual",
            name: "insurancePremiumActual",
            label: <Label label={"Insurance Premium Actual"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "growthPercent",
            name: "growthPercent",
            label: <Label label={"Policy Growth Rate"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            allowMax100: true,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "growthAmount",
            name: "growthAmount",
            label: <Label label={"Growth Dollar Amount Earned"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "actualSurrenderValue",
            name: "actualSurrenderValue",
            label: <Label label={"Actual Surrender Value"} />,
            isRequired: true,
            component: NumberTextFieldWithCb,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                // const bankLoanAmountVal = numeral(values.bankLoanAmount).value();
                //PolicyBreakDowns.actualNetSurrenderValue[0] = {PolicyBreakDowns.actualSurrenderValue[0]} - {PolicyBreakDowns.bankLoanAmount[0]}
                // const result = val - bankLoanAmountVal;
                //setFieldValue("actualNetSurrenderValue", result + "");
                setFieldValue("actualSurrenderValue", val + "");
            },
            allowNegative: false,
        },
        {
            id: "actualCurrentDeathBenefit",
            name: "actualCurrentDeathBenefit",
            label: <Label label={"Actual Current Death Benefits"} />,
            isRequired: true,
            component: NumberTextFieldWithCb,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                const bankLoanAmountVal = numeral(values.bankLoanAmount).value();
                //PolicyBreakDowns.netDeathBenefitActual[0] =  actualCurrentDeathBenefit[0] - bankLoanAmount[0]
                const result = calculateNetDeathBenefit(val, bankLoanAmountVal);
                setFieldValue("netDeathBenefitActual", parseAndFormat(result));
                setFieldValue("actualCurrentDeathBenefit", val);
            },
            allowNegative: false,
        },
        {
            id: "actualLowPoint",
            name: "actualLowPoint",
            label: <Label label={"Actual Low Point"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "actualNetSurrenderValue",
            name: "actualNetSurrenderValue",
            label: <Label label={"Net of Loan Cash Value Actual"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            // disabled: true,
            allowNegative: false,
        },
        {
            id: "netDeathBenefitActual",
            name: "netDeathBenefitActual",
            label: <Label label={"Net Death Benefit Actual"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            // disabled: true,
        },
    ]

    const bankValues = [
        {
            id: "bankLoanPremiumDue",
            name: "bankLoanPremiumDue",
            label: <Label label={"Bank Loan Premium Paid"} />,
            icon: true,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                const bankInterestRate = numeral(values.bankInterestRate).value();
                const arrangementFee = numeral(caseDetails && caseDetails.tranche && caseDetails.tranche.bankDetails && caseDetails.tranche.bankDetails[0].totalArrangementFee).value();
                const bankLoanBasis = addNumbers(foundEstimatedLB, val, arrangementFee);
                const dailyIA = dailyInt(bankLoanBasis, bankInterestRate);
                const intAccruedYTD = intAccrued(Number(dailyIA), anniversaryDate);
                const actualInterestAmount = actualIntAmt(bankLoanBasis, bankInterestRate);
                isDebug() && console.log("Actual Interest Amount", actualInterestAmount);

                setFieldValue("bankLoanPremiumDue", val);
                setFieldValue("bankLoanBasis", bankLoanBasis);
                setFieldValue("dailyInterestAccrual", dailyIA);
                setFieldValue("interestAccruedYTD", intAccruedYTD);
                setFieldValue("loanBalanceYTD", addNumbers(bankLoanBasis, intAccruedYTD));
                setFieldValue("actualInterestAmount", actualInterestAmount);
                setFieldValue("bankLoanAmount", addNumbers(bankLoanBasis, actualInterestAmount));

                if (checkRole(user.role, [AccountType.MasterAdmin, AccountType.Admin])) {
                    setFieldValue("bankLoanPremiumDueUpdated", true);
                }
            },
        },
        {
            id: "bankInterestRate",
            name: "bankInterestRate",
            label: <Label label={"Bank Interest Rate"} />,
            icon: true,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            allowMax100: true,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                const bankLoanBasis = numeral(values.bankLoanBasis).value();
                const dailyIA = dailyInt(bankLoanBasis, val);
                const intAccruedYTD = intAccrued(Number(dailyIA), anniversaryDate);
                const actualInterestAmount = actualIntAmt(bankLoanBasis, val);

                setFieldValue("bankInterestRate", val);
                setFieldValue("dailyInterestAccrual", dailyInt(bankLoanBasis, val));
                setFieldValue("interestAccruedYTD", intAccruedYTD);
                setFieldValue("actualInterestAmount", actualInterestAmount);
                setFieldValue("loanBalanceYTD", addNumbers(bankLoanBasis, intAccruedYTD));
                setFieldValue("bankLoanAmount", addNumbers(bankLoanBasis, actualInterestAmount));

                if (checkRole(user.role, [AccountType.MasterAdmin, AccountType.Admin])) {
                    setFieldValue("bankInterestRateUpdated", true);
                }
            },
        },
        {
            id: "bankLoanBasis",
            name: "bankLoanBasis",
            label: <Label label={"Bank Loan Basis"} />,
            icon: true,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                const bankInterestRate = numeral(values.bankInterestRate).value();
                const dailyIA = dailyInt(val, bankInterestRate);
                const intAccruedYTD = intAccrued(Number(dailyIA), anniversaryDate);
                const actualInterestAmount = actualIntAmt(val, bankInterestRate);

                setFieldValue("bankLoanBasis", val);
                setFieldValue("dailyInterestAccrual", dailyInt(val, bankInterestRate));
                setFieldValue("interestAccruedYTD", intAccruedYTD);
                setFieldValue("loanBalanceYTD", addNumbers(val, intAccruedYTD));
                setFieldValue("actualInterestAmount", actualInterestAmount);
                setFieldValue("bankLoanAmount", addNumbers(val, actualInterestAmount));

                if (checkRole(user.role, [AccountType.MasterAdmin, AccountType.Admin])) {
                    setFieldValue("bankLoanBasisUpdated", true);
                }
            },
        },
        {
            id: "dailyInterestAccrual",
            name: "dailyInterestAccrual",
            label: <Label label={"Daily Interest Accrual"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            disabled: true,
            allowNegative: false,
        },
        {
            id: "interestAccruedYTD",
            name: "interestAccruedYTD",
            label: <Label label={"Interest Accrued YTD"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            disabled: true,
            allowNegative: false,
        },
        {
            id: "loanBalanceYTD",
            name: "loanBalanceYTD",
            label: <Label label={"Loan  Balance YTD"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            disabled: true,
            allowNegative: false,
        },
        {
            id: "actualInterestAmount",
            name: "actualInterestAmount",
            label: <Label label={"Actual Interest Amount"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            disabled: true,
            allowNegative: false,
        },
        {
            id: "bankLoanAmount",
            name: "bankLoanAmount",
            label: <Label label={"Estimated Loan Balance"} />,
            isRequired: true,
            component: NumberTextFieldWithCb,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            cb: (e: any) => {
                updateSurrenderValues(e, true);
            },
            disabled: true,
            allowNegative: false,
        },
        {
            id: "arrangementFee",
            name: "arrangementFee",
            label: <Label label={"Arrangement Fee"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                    position="start">$</InputAdornment>,
            },
            disabled: false,
            allowNegative: false,
        },
    ]

    const annualStatement = [
        {
            id: "stmCumulativePaidToPolicy",
            name: "stmCumulativePaidToPolicy",
            label: <Label label={"Cumulative Paid To Policy"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "stmSurrenderValue",
            name: "stmSurrenderValue",
            label: <Label label={"Statement Surrender Value"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                const estLoanBalanceVal = numeral(values.estLoanBalance).value();
                const result = calculateNetStmSurrenderValue(val, estLoanBalanceVal);
                setFieldValue("netStmSurrenderValue", parseAndFormat(result));
                setFieldValue("stmSurrenderValue", val)
            },
            allowNegative: false,
        },
        {
            id: "stmPremium",
            name: "stmPremium",
            label: <Label label={"Statement Premium"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "stmDeathBenefit",
            name: "stmDeathBenefit",
            label: <Label label={"Statement Death Benefits"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            cb: (e: any) => {
                const val = numeral(e.target.value).value();
                const estLoanBalanceVal = numeral(values.estLoanBalance).value();
                const result = calculateNetStmDeathBenefits(val, estLoanBalanceVal);
                setFieldValue("netStmDeathBenefits", parseAndFormat(result));
                setFieldValue("stmDeathBenefit", val)
            },
            allowNegative: false,
        },
        {
            id: "netStmSurrenderValue",
            name: "netStmSurrenderValue",
            label: <Label label={"Net Statement Surrender Value"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "netStmDeathBenefits",
            name: "netStmDeathBenefits",
            label: <Label label={"Net Statement Death Benefits"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        }
    ]
    const confirmationStatement = [
        {
            id: "stmTotalCreditedAmount",
            name: "stmTotalCreditedAmount",
            label: <Label label={"Total Credited Amount"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "stmTotalValue",
            name: "stmTotalValue",
            label: <Label label={"Total Value"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
        },
        {
            id: "stmWeightedGrowthRate",
            name: "stmWeightedGrowthRate",
            label: <Label label={"Weighted Growth Rate"} />,
            isRequired: true,
            component: NumberTextField,
            filedType: "number",
            variant: "outlined",
            className: "fullWidthcustomFields",
            allowMax100: true,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
        }
    ]

    // const chakdefateey = () => {
        const polVal = policyArr[policyArrIndex];
        const fullSurrender = polVal && polVal.surrenderCompleted === 1;
        const cashOut = polVal && polVal.surrenderCompleted === 2;
        const surrenderCashOutAction = polVal && polVal.surrenderCashOutAction;

        // return { fullSurrender, cashOut, FullSurrenderYes, CashOutSurrenderYes };
    // };
    // const { fullSurrender, cashOut, FullSurrenderYes, CashOutSurrenderYes } = chakdefateey();

    const surrenderValues = [
        {
            id: "loanAmount",
            name: "loanAmount",
            label: <Label label={"Loan Amount"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            isVisible: true,
        },
        {
            id: "actualCurrentSurrenderValue",
            name: "actualCurrentSurrenderValue",
            label: <Label label={"Actual Current Surrender Value"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            isVisible: true,
        },
        {
            id: "amountPaidToClient",
            name: "amountPaidToClient",
            label: <Label label={"Amount Paid to Client"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            isVisible: true,
        },
        {
            id: "dateOfSurrender",
            name: "dateOfSurrender",
            label: <Label label={"Date of Surrender"} />,
            isRequired: true,
            component: DatePicker,
            variant: "outlined",
            className: "fullWidthcustomFields",
            allowNegative: false,
            sizeMd: 6,
            isVisible: true,
        },
        {
            id: "perDiem",
            name: "perDiem",
            label: <Label label={"Per Diem"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            isVisible: true,
        },

        {
            id: "surrenderCompleted",
            name: "surrenderCompleted",
            label: <Label label={"Surrender Option"} />,
            isRequired: true,
            component: SelectField,
            className: "fullWidthcustomFields",
            variant: "outlined",
            options: surrenderOptions,
            allowNegative: false,
            filedType: "text",
            onSelectChange: (e) => {
                handleSelectFieldChange(e, "surrenderCompleted", SelectField);
            },
            isVisible: true,
        },

        {
            id: "surrenderCashOutAction",
            name: "surrenderCashOutAction",
            label: <Label label={fullSurrender ? "Surrender Completed" : "Will this account continue to be serviced?"} />,
            isRequired: true,
            component: SelectField,
            variant: "outlined",
            options: yesNoDropDown,
            allowNegative: false,
            filedType: "text",
            onSelectChange: (e) => {
                handleSelectFieldChange(e, "continueService", SelectField);
            },
            isVisible: fullSurrender || cashOut,
        },

        {
            id: "reasonForChange",
            name: "reasonForChange",
            label: <Label label={"Reason for Change"} required={true}/>,
            component: TextField,
            multiline: true,
            variant: "outlined",
            rows: 3,
            rowsMax: 6,
            sizeMd: 12,
            sizeLg: 12,
            isVisible: surrenderCashOutAction,
        },
    ];

    const actualValues:any = [
        {
            id: "amountPaidToPolicy",
            name: "amountPaidToPolicy",
            label: <Label label={"Cumulative Amount Paid To Policy"} />,
            isRequired: true,
            component: NumberTextFieldWithCb,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            cb: (e: any) => {
                updateSurrenderValues(e);
            },
            allowNegative: false,
            // disabled: true,
        },

        {
            id: "cumulativeContributionPaid",
            name: "cumulativeContributionPaid",
            label: <Label label={"Cumulative Client Contribution Paid"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            // disabled: true,
        },
        {
            id: "cumulativeEmployerContributionPaid",
            name: "cumulativeEmployerContributionPaid",
            label: <Label label={"Cumulative Employer Contribution Paid"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            // disabled: true,
        },
        {
            id: "cumulativeBankLoanPremiumPaid",
            name: "cumulativeBankLoanPremiumPaid",
            label: <Label label={"Cumulative Bank Loan Premium Paid"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">$</InputAdornment>,
            },
            allowNegative: false,
            // disabled: true,
        },
        {
            id: "growthRateAverage",
            name: "growthRateAverage",
            label: <Label label={"Growth Rate Average"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            allowMax100: true,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
            // disabled: true,
        },
        {
            id: "loanRateAverage",
            name: "loanRateAverage",
            label: <Label label={"Loan Rate Average"} />,
            isRequired: true,
            component: NumberTextField,
            variant: "outlined",
            filedType: "number",
            className: "fullWidthcustomFields",
            allowMax100: true,
            InputProps: {
                startAdornment: <InputAdornment className="margin0 dollerIcon"
                                                position="start">%</InputAdornment>,
            },
            allowNegative: false,
            // disabled: true,
        },
    ];
    const allocationsFields: AllocationField = {
        id: undefined,
        allocationId: "",
        optionName: "",
        indexAllocationPercent: "",
        indexCreditAmount: "",
        indexCreditPercent: "",
        indexBonusAmount: "",
        indexParticipationRate:"",
        indexCap:"",
        indexCurrentValue:"",
        indexLock:"",
    }

    // Sync form values to policyArr
    // Note: This runs on every form change but is necessary to keep policyArr in sync
    // Individual field updates are also handled in handleBlur for more immediate updates
    useEffect(() => {
        if (fieldObj && fieldObj.length > 0) {
            const obj: any = {};

            // Process all field configurations
            [...fieldObj, ...illustratedValue, ...actualValues, ...carrierValues, ...bankValues, ...annualStatement, ...confirmationStatement, ...surrenderValues].forEach(field => {
                obj[field.name] = numeral(values[field.name]).value();
            });

            obj["adminClientAllocations"] = values["adminClientAllocations"];
            obj["policyYear"] = year;
            obj["id"] = yearPolicyBreakup.id || null;
            obj["clientPolicyId"] = caseDetails.id;

            // Track bank value manual updates
            if (values["bankLoanPremiumDueUpdated"]) {
                obj["bankLoanPremiumDueUpdated"] = true;
            }
            if (values["bankInterestRateUpdated"]) {
                obj["bankInterestRateUpdated"] = true;
            }
            if (values["bankLoanBasisUpdated"]) {
                obj["bankLoanBasisUpdated"] = true;
            }
            if (values["dbNotes"]) {
                obj["dbNotes"] = values["dbNotes"];
            }
            if (values["decliningDB"]) {
                obj["decliningDB"] = values["decliningDB"];
            }
            if (values["decliningDB"] === 2 && values["decliningDBOther"]) {
                obj["decliningDBOther"] = values["decliningDBOther"];
            } else {
                obj["decliningDBOther"] = "";
            }
            policyArr[policyArrIndex] = obj;
            setPolicyArr(policyArr);
            setRefresh();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values]);

    useEffect(() => {
        const policyYear = policy && policy.premium && policy.premium.policyStartDate;
        const date = new Date(policyYear);
        const year = date.getFullYear();
        if((policy && policy.flexiPayments && policy.flexiPayments.length > 0) && paymentFrequency === PaymentFrequency.Monthly) {
            if (year) {
                const group = groupMonthlyRecords(policy.flexiPayments, year);
                if (group && Object.keys(group).length > 0) {
                    setPaymentData(group)
                } else {
                    setPaymentData({})
                }
            }
        } else if((policy && policy.flexiPayments && policy.flexiPayments.length > 0) && paymentFrequency === PaymentFrequency.Annual) {
            if (year) {
                const group = groupAnnualRecords(policy.flexiPayments, year);
                if (group && Object.keys(group).length > 0) {
                    setPaymentData(group)
                } else {
                    setPaymentData({})
                }
            }
        } else {
            setPaymentData({})
        }

    },[]);

    const handleBlur = useCallback((e, name) => {
        let polVal = policyArr[policyArrIndex];
        if (name.substr(0, 16) === "adminClientAllocations") {
            polVal[`${name}`] = (e.target as HTMLInputElement).value;
        } else if ((name === "dbNotes") || (name === "decliningDBOther")) {
            polVal[`${name}`] = (e.target as HTMLInputElement).value;
        } else {
            polVal[`${name}`] = numeral((e.target as HTMLInputElement).value).value();
        }
        policyArr[policyArrIndex] = polVal;
        isDebug() && console.info({polVal})
        setPolicyArr(policyArr);
        setRefresh();
        setPolicyFormDirty();
    }, [policyArr, policyArrIndex, setPolicyArr, setRefresh, setPolicyFormDirty]);

    const handleDateBlur = useCallback((val: any, name: string) => {
        const date = moment(val).format("YYYY-MM-DD");
        const polVal = policyArr[policyArrIndex];
        polVal[`${name}`] = date;
        policyArr[policyArrIndex] = polVal;
        setPolicyArr(policyArr);
        setRefresh();
        setPolicyFormDirty();
    }, [policyArr, policyArrIndex, setPolicyArr, setRefresh, setPolicyFormDirty]);

    const handleSelectFieldChange = useCallback((val: any, name: string, component: any) => {
        const polVal = policyArr[policyArrIndex];
        let value:any;
        // const { fullSurrender, cashOut, FullSurrenderYes, CashOutSurrenderYes } = chakdefateey();
        // console.log({ fullSurrender, cashOut, CashOutSurrenderYes, FullSurrenderYes }," polVal-------")
        // if (CashOutSurrenderYes) {
        //     polVal.surrenderCompleted = '';
        //     polVal.continueService = '';
        //     polVal.reasonForChange = '';
        // } else if (FullSurrenderYes) {
        //     polVal.continueService = '';
        //     polVal.surrenderCompleted = '';
        //     polVal.reasonForChange = '';
        // }


        if (component === NumberTextField) {
            value = numeral(val.target.value).value();
        } else if (component === DatePicker) {
            value = val;
        } else if (component === SelectField) {
            value = val;
        } else if (component === TextField) {
            value = val.target.value;
        } else {
            value = val;
        }

        polVal[`${name}`] = value;



        policyArr[policyArrIndex] = polVal;
        setPolicyArr(policyArr);
        setRefresh();
        setPolicyFormDirty();
    }, [policyArr, policyArrIndex, setPolicyArr, setRefresh, setPolicyFormDirty]);

    const groupMonthlyRecords = (data, policyStart) => {
        const groupedData = {};
        let currentYear = policyStart;

        for (let i = 0; i < data.length; i += 12) {
            const group = data.slice(i, i + 12);

            if (!groupedData[currentYear]) {
                groupedData[currentYear] = [];
            }

            groupedData[currentYear].push(...group);
            currentYear++;
        }

        return groupedData;
    };
    const groupAnnualRecords = (data, policyStart) => {
        const groupedData = {};
        let currentYear = policyStart;

        for (let i = 0; i < data.length; i++) {
            groupedData[currentYear] = data[i];
            currentYear++;
        }

        return groupedData;
    }

    const handleDelete = async (id: number, index: number) => {
        try {
            if (id){
                await accountActions.deleteAdminAllocation(id);}
            const newAllocations = [...values.adminClientAllocations];
            newAllocations.splice(index, 1);
            setFieldValue("adminClientAllocations", newAllocations);
        } catch (error) {
            console.error('Failed to delete allocation:', error);
            // TODO: Add user-facing error notification (toast/snackbar)
        }
    };

    const handleRemoveFocus = () => {
        const el = inputRefs.current[activeField];
        if (el && typeof el.blur === "function") el.blur();
    };

    const dialogProps: GenericDialogProps = {
        actions: (
                <>
                    <Button
                            label={"Cancel"}
                            type="button"
                            variant="contained"
                            color="primary"
                            onMouseDown={() => {
                                handleRemoveFocus();
                                setBVPopUpOpen(false);
                            }}
                            className="btnContainedRed floatRight mr20"
                    />
                    <Button
                            label={"Edit"}
                            type="submit"
                            variant="contained"
                            onClick={() => {
                                setFieldValue(`${activeField}Updated`, true);
                                setBVPopUpOpen(false);
                            }}
                            color="primary"
                            className="floatRight mr20"
                    />
                </>
        ),
        "aria-labelledby": "pop-up",
        content: ("The displayed value was generated from an automated source. Editing will override the value for this field only. The source will remain unchanged. Continue?"),
        onClose: () => {
            handleRemoveFocus();
            setBVPopUpOpen(false);
        },
        open: bVPopUpOpen,
        title: "Edit Bank Values",
    };

    return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <span className="hLine" />
                    </Grid>
                    {
                        fieldObj.map((field, index) => {
                        return (
                                <Grid item xs={12} md={6} xl={6}
                                      key={index} className="mb15">
                                    <TextFieldCommon
                                            {...field}
                                            name={field.name}
                                            values={values}
                                            onChange={handleChange}
                                            onBlur={(e) => handleBlur(e, field.name)}
                                            cb={(da) => {
                                                setTimeout(() => {
                                                    handleDateBlur(da, field.name);
                                                }, 1000);
                                            }}
                                    />
                                    <ErrorCommon errors={errors} name={field.name}
                                                 touched={touched} />
                                </Grid>
                        );
                    })
                    }

                    <Grid item xs={12} md={6} xl={6} className="dbRequest">
                        {!uploadClientDBRequest ?
                                <div className={classes.fileUpload}>
                                    <FileUploader
                                            exactFileName={"Upload client DB request"}
                                            dirName={directory}
                                            dirType={"documents"}
                                            fileType={fileType}
                                            width={15000}
                                            height={15000}
                                            content={"Upload client DB request"}
                                            onFinish={async (publicUrl: string, name: string) => {
                                                await updateDocument("dbRequest", name, ClientDocumentType.DEATH_BENEFIT_REQUEST, "", 'Death Benefit Request');
                                                setUploadClientDBRequest(name);
                                                setTimeout(async () => {
                                                    await accountActions.getProfileDetails();
                                                }, 2000);
                                            }}
                                    />
                                </div>
                                :
                                <ViewAndDelete
                                        identityPhoto={uploadClientDBRequest}
                                        clientSigned={clientSigned}
                                        title="Death Benefit Request"
                                        action={
                                            {
                                                key: "dbRequest",
                                                type: ClientDocumentType.DEATH_BENEFIT_REQUEST,
                                                side: "",
                                            }
                                        }
                                        userId={caseDetails && caseDetails.client && caseDetails.client.userId}
                                        directory={directory}
                                        setUploadClientDBRequest={setUploadClientDBRequest}
                                        clientPolicyId={caseDetails && caseDetails.id}
                                        enableDelete={true}
                                        policyYear={year}
                                />
                        }
                    </Grid>

                    <Grid item xs={12} md={6} xl={6}>
                        <FormControl variant="outlined">
                            <InputLabel id="reason-for-declining-db-reduction">Reason for declining DB reduction:</InputLabel>
                            <Select
                                    labelId="reason-for-declining-db-reduction"
                                    id="reason-for-declining-db-reduction"
                                    value={decliningDB}
                                    name="decliningDB"
                                    onChange={e => {
                                        const val: any = e.target.value;
                                        setDecliningDB(val);
                                        handleChange(e);
                                    }}
                                    onBlur={(e) => {
                                        handleBlur(e, "decliningDB");
                                    }}
                                    label="Reason for declining DB reduction:"
                            >
                                <MenuItem value={0}> Select Reason </MenuItem>
                                <MenuItem value={1}> Health </MenuItem>
                                <MenuItem value={2}> Other </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        {
                                decliningDB === 2 &&
                                <>
                                    <TextFieldCommon
                                            id="decliningDBOther"
                                            name="decliningDBOther"
                                            component={TextField}
                                            values={values}
                                            multiline={true}
                                            onChange={handleChange}
                                            onBlur={(e) => handleBlur(e, "decliningDBOther")}
                                            label={<Label label={"Other"} />}
                                    />
                                </>
                        }
                    </Grid>

                    <Grid item xs={12}>
                        {
                                addDbNotes &&
                                <>
                                    <TextFieldCommon
                                            id="dbNotes"
                                            name="dbNotes"
                                            component={TextField}
                                            values={values}
                                            multiline={true}
                                            onChange={handleChange}
                                            onBlur={(e) => handleBlur(e, "dbNotes")}
                                            label={<Label label={"Add Notes"} />}
                                    />
                                </>
                        }
                        {
                                !addDbNotes &&
                                <>
                                    <Button
                                            color={"primary"}
                                            size={"small"}
                                            variant={"contained"}
                                            label={"Add Notes"}
                                            onClick={() => {
                                                setAddDbNotes(true);
                                            }}
                                    ></Button>
                                </>
                        }
                    </Grid>

                    <Grid item xs={12}>
                        <FlexiPayments
                            year={year}
                            frequency={paymentFrequency}
                            paymentData={paymentData[year]}
                        />
                       <FieldArray name="adminClientAllocations">
                        {({ remove,push }) => (
                                <>
                                    <Grid item xs={12}>
                                        <ExpansionPanel>
                                            <ExpansionPanelSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                            >
                                                <Typography variant="body1" className="mb0">Index Options</Typography>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails style={{ display: "block" }}>
                                                {values.adminClientAllocations && values.adminClientAllocations.map((field, index) => {
                                                                    const selectedOption = optionName.find((opt: any) => opt.value === values.adminClientAllocations[index].allocationId);
                                                                    const isOtherSelected = selectedOption && selectedOption.name === "Other";
                                                                    
                                                                    return (
                                                        <Grid container spacing={2}>
                                                            {adminClientAllocations.map((fieldProps, i: any) => {
                                                                    // Skip conditional fields if condition is not met
                                                                    if (fieldProps.conditional && !isOtherSelected) {
                                                                        return null;
                                                                    }
                                                                    
                                                                    return (
                                                                    <>

                                                                    <Grid item key={i} xs={12} md={6} lg={6}>
                                                                        <Field
                                                                                {...fieldProps}
                                                                                id={`adminClientAllocations.${index}.${fieldProps.name}`}
                                                                                name={`adminClientAllocations.${index}.${fieldProps.name}`}
                                                                                onChange={handleChange}
                                                                                onBlur={(e) => handleBlur(e, `adminClientAllocations.${index}.${fieldProps.name}`)}
                                                                                value={values.adminClientAllocations[index][fieldProps.name]}
                                                                                fullWidth
                                                                        />
                                                                        <ErrorCommon errors={errors}
                                                                                     name={`adminClientAllocations.${index}.${fieldProps.name}`}
                                                                                     touched={touched} />
                                                                    </Grid>

                                                                    </>
                                                            )}
                                                            )}
                                                            <Grid xs={12}>
                                                                <span className="hLine" />
                                                            </Grid>
                                                            {index >= MIN_DELETABLE_ALLOCATION_INDEX && (
                                                                    <IconButton style={{
                                                                        position: "absolute",
                                                                        right: -10,
                                                                        zIndex: 1,
                                                                    }}
                                                                                onClick={() => handleDelete(field.id, index)}>
                                                                        <DeleteIcon className="colorRed" />
                                                                    </IconButton>
                                                            )}
                                                        </Grid>
                                                    );
                                                })}
                                            </ExpansionPanelDetails>
                                        </ExpansionPanel>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                                color={"primary"}
                                                size={"small"}
                                                variant={"contained"}
                                                label={"Add Allocation"}
                                                onClick={() => push(allocationsFields)}>
                                        </Button>
                                    </Grid>
                                </>
                        )}
                    </FieldArray>
                    </Grid>
                    <Grid item xs={12}>
                        <span className="hLine" />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1"><strong>Illustrated Values</strong></Typography>
                    </Grid>

                    {
                        illustratedValue.map((field, index) => {
                        return (
                                <Grid item xs={6} md={6} xl={4}
                                      key={index} className="mb15">
                                    <TextFieldCommon
                                            {...field}
                                            name={field.name}
                                            values={values}
                                            onChange={field.cb ? field.cb : handleChange}
                                            onBlur={(e) => handleBlur(e, field.name)}
                                    />
                                    <ErrorCommon errors={errors} name={field.name}
                                                 touched={touched} />
                                </Grid>
                        );
                    })
                    }
                    <Grid item xs={12}>
                        <span className="hLine" />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1"><strong>Actual Values</strong></Typography>
                    </Grid>

                    {
                        actualValues.map((field, index) => {
                        return (
                                <Grid item xs={6} md={6} xl={4}
                                      key={index} className="mb15">
                                    <TextFieldCommon
                                            {...field}
                                            name={field.name}
                                            values={values}
                                            onChange={field.cb ? field.cb : handleChange}
                                            onBlur={(e) => handleBlur(e, field.name)}
                                    />
                                    <ErrorCommon errors={errors} name={field.name}
                                                 touched={touched} />
                                </Grid>
                        );
                    })
                    }
                    <Grid item xs={12}>
                        <Typography variant="body1"><strong>Carrier Values - Feeds</strong></Typography>
                    </Grid>
                    {carrierValues.map((field, index) => {
                        return (
                                <Grid item xs={6} md={6} xl={4}
                                      key={index} className="mb15">
                                    <TextFieldCommon
                                            {...field}
                                            name={field.name}
                                            values={values}
                                            onChange={field.cb ? field.cb : handleChange}
                                            onBlur={(e) => handleBlur(e, field.name)}
                                    />
                                    <ErrorCommon errors={errors} name={field.name}
                                                 touched={touched} />
                                </Grid>
                        );
                    })
                    }
                    <Grid item xs={12}>
                        <Typography variant="body1"><strong>Bank Values</strong></Typography>
                    </Grid>
                    {bankValues.map((field, index) => {
                        return (
                                <Grid item xs={6} md={6} xl={4}
                                      key={index} className="mb15">
                                    <TextFieldCommon
                                            {...field}
                                            name={field.name}
                                            values={values}
                                            onChange={field.cb ? field.cb : handleChange}
                                            onBlur={(e) => handleBlur(e, field.name)}
                                            onClick={(e) => {
                                                if (field.icon) {
                                                    const filedName = `${field.name}Updated`;
                                                    const updatedVal = values ? values[filedName] : "";
                                                    if (!updatedVal) {
                                                        setBVPopUpOpen(true);
                                                    }
                                                }
                                            }}
                                            innerRef={(el) => (inputRefs.current[field.name] = el)}
                                            onFocus={() => setActiveField(field.name)}
                                    />
                                    <ErrorCommon errors={errors} name={field.name}
                                                 touched={touched} />
                                </Grid>
                        );
                    })
                    }
                    <Grid item xs={12}>
                        <Typography variant="body1"><strong>Statement Values</strong></Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1">Annual Statement</Typography>
                    </Grid>
                    {annualStatement.map((field, index) => {
                        return (
                                <Grid item xs={6} md={6} xl={4}
                                      key={index} className="mb15">
                                    <TextFieldCommon
                                        {...field}
                                        name={field.name}
                                        values={values}
                                        onChange={field.cb ? field.cb : handleChange}
                                        onBlur={(e) => handleBlur(e, field.name)}
                                    />
                                    <ErrorCommon errors={errors} name={field.name}
                                        touched={touched} />
                                </Grid>
                        );
                    })
                    }
                    <Grid item xs={12}>
                        <Typography variant="body1">Confirmation Statement</Typography>
                    </Grid>
                    <Grid item xs={12} className="mb20">
                        <Typography variant="body1" className="mb10">Index Options</Typography>
                        {values.statementAllocations && values.statementAllocations.map((allocation, index) => {
                            const selectedOption = optionName.find((opt: any) => opt.value === values.statementAllocations[index].allocationId);
                            const isOtherSelected = selectedOption && selectedOption.name === "Other";
                            return (
                                <Grid container spacing={2}>
                                    {adminClientAllocations.map((fieldProps, i: any) => {
                                        // Skip conditional fields if condition is not met
                                        if (fieldProps.conditional && !isOtherSelected) {
                                            return null;
                                        }
                                        return (
                                            <>
                                            <Grid item key={i} xs={12} md={6} lg={6}>
                                                <Field
                                                        {...fieldProps}
                                                        id={`statementAllocations.${index}.${fieldProps.name}`}
                                                        name={`statementAllocations.${index}.${fieldProps.name}`}
                                                        onChange={handleChange}
                                                        onBlur={(e) => handleBlur(e, `statementAllocations.${index}.${fieldProps.name}`)}
                                                        value={values.statementAllocations[index][fieldProps.name]}
                                                        fullWidth
                                                        disabled
                                                />
                                                <ErrorCommon errors={errors}
                                                            name={`statementAllocations.${index}.${fieldProps.name}`}
                                                            touched={touched} />
                                            </Grid>
                                            </>
                                        )}
                                        )
                                    }
                                </Grid>
                            )
                    })
                    }
                    </Grid>
                    {confirmationStatement.map((field, index) => {
                        return (
                            <Grid item xs={6} md={6} xl={4}
                                  key={index} className="mb15">
                                <TextFieldCommon
                                        {...field}
                                        name={field.name}
                                        values={values}
                                        onChange={handleChange}
                                        onBlur={(e) => handleSelectFieldChange(e, field.name, field.component)}
                                        cb={(da) => {
                                            setTimeout(() => {
                                                handleSelectFieldChange(da, field.name, field.component);
                                            }, 1000);
                                        }}
                                        disabled
                                />
                                <ErrorCommon errors={errors} name={field.name}
                                             touched={touched} />
                            </Grid>
                        );
                    })}

                    <Grid item xs={12}>
                        <Typography variant="body1"><strong>Surrender Values</strong></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        {
                            surrenderValues.filter(field => field.isVisible).map((field: any, index) => {
                                return (
                                        <Grid item
                                              xs={12}
                                              md={field.sizeMd || 6}
                                              xl={field.sizeLg || 4}
                                              key={field.id || index}
                                              className="mb15"
                                        >
                                            <TextFieldCommon
                                                    {...field}
                                                    name={field.name}
                                                    values={values}
                                                    required={field.isRequired}
                                                    onChange={handleChange}
                                                    onBlur={(e) => handleSelectFieldChange(e, field.name, field.component)}
                                                    cb={(da) => {
                                                        setTimeout(() => {
                                                            handleSelectFieldChange(da, field.name, field.component);
                                                        }, 1000);
                                                    }}
                                            />
                                            <ErrorHelper errors={errors} name={field.name} />
                                        </Grid>
                                );
                            })
                        }
                    </Grid>
                    <PolicyYearDocTable yearPolicyBreakup={yearPolicyBreakup} caseDetails={caseDetails} />
                </Grid>

                <GenericDialog {...dialogProps} />

            </React.Fragment>
    );
};
export default BreakDownFormPanel1;